module.exports = __webpack_public_path__ + "static/media/ENT-Medical History Intake-2@3x.c573dcae.png";